import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Landing from "@/components/Landing";
import Impressum from "@/components/Impressum";
import Datenschutz from "@/components/Datenschutz";
import Kontakt from "@/components/Kontakt";
import Danke from "@/components/Danke";

function ScrollManager() {
  const loc = useLocation();
  useEffect(() => {
    if (loc.state && loc.state.scrollTo) return; // Landing handles section scroll
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [loc.pathname, loc.state]);
  return null;
}

function App() {
  return (
    <SmoothScroll>
      <div className="relative min-h-screen bg-paper text-ink antialiased">
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#ffffff",
              border: "1px solid rgba(20,18,15,0.1)",
              color: "#14120f",
            },
          }}
        />
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/kontakt/danke" element={<Danke />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </BrowserRouter>
      </div>
    </SmoothScroll>
  );
}

export default App;
